<template>
  <v-app>
    <v-main class="login-container" :style="backgroundStyle">
      <Loading :isActive="loading" />

      <!-- Overlay escuro -->
      <div class="overlay-dark"></div>

      <v-container fluid class="fill-height">
        <v-row justify="center" align="center">
          <v-col cols="12" lg="10" xl="8">
            <v-fade-transition>
              <v-card
                v-if="true"
                class="login-card"
                elevation="24"
              >
                <v-row no-gutters>
                  <!-- Coluna Promocional (Esquerda) -->
                  <v-col
                    cols="12"
                    md="6"
                    class="promotional-section d-none d-md-flex"
                    :style="promotionalBackground"
                  >
                    <div class="promotional-overlay">
                      <div class="promotional-content">
                        <v-slide-y-transition>
                          <div v-if="true" class="text-white">
                            <!-- Badge -->
                            <div class="badge-novidade mb-4">
                              ✨ Painel Administrativo
                            </div>

                            <!-- Título -->
                            <h1 class="promotional-title mb-4">
                              Gestão Completa
                            </h1>

                            <!-- Descrição -->
                            <p class="promotional-description mb-6">
                              Controle total das suas aplicações de venda.
                            </p>
                          </div>
                        </v-slide-y-transition>
                      </div>
                    </div>
                  </v-col>

                  <!-- Coluna do Formulário (Direita) -->
                  <v-col cols="12" md="6">
                    <div class="form-section">
                      <!-- Logo -->
                      <div class="text-center mb-6">
                        <img
                          :src="logo"
                          alt="Logo"
                          class="form-logo"
                        />
                      </div>

                      <!-- Cabeçalho -->
                      <div class="text-center mb-8">
                        <h2 class="form-title">
                          {{ mode === "forgot" ? "Recuperar senha" : "Bem-vindo" }}
                        </h2>
                        <p class="form-subtitle">
                          {{ subtitle }}
                        </p>
                      </div>

                      <!-- Formulário de Login -->
                      <v-form v-if="mode === 'login'" @submit.prevent="onSubmit">
                        <v-text-field
                          v-model="user"
                          label="Matrícula, CPF ou Email"
                          outlined
                          dense
                          required
                          autofocus
                          autocomplete="username email"
                          class="mb-2"
                          :error-messages="loginError ? ' ' : ''"
                        ></v-text-field>

                        <v-text-field
                          v-model="pass"
                          label="Senha"
                          outlined
                          dense
                          required
                          autocomplete="current-password"
                          class="mb-1"
                          :type="showPassword ? 'text' : 'password'"
                          :error-messages="loginError ? ' ' : ''"
                        >
                          <template v-slot:append>
                            <v-icon
                              small
                              @click="showPassword = !showPassword"
                              style="cursor: pointer"
                            >
                              <fa-icon :icon="showPassword ? 'eye-slash' : 'eye'" />
                            </v-icon>
                          </template>
                        </v-text-field>

                        <!-- Esqueci minha senha -->
                        <div class="text-right mb-4">
                          <a
                            href="#"
                            class="forgot-password-link"
                            @click.prevent="switchMode('forgot')"
                          >
                            Esqueci minha senha
                          </a>
                        </div>

                        <!-- Mensagem de Erro -->
                        <v-fade-transition>
                          <v-alert
                            v-if="loginError"
                            type="error"
                            dense
                            text
                            class="mb-4"
                          >
                            {{ loginError }}
                          </v-alert>
                        </v-fade-transition>

                        <!-- Botão de Login -->
                        <v-btn
                          type="submit"
                          color="primary"
                          x-large
                          block
                          elevation="4"
                          class="login-button mb-4"
                          :loading="loading"
                        >
                          <fa-icon icon="sign-in-alt" class="mr-2" />
                          Entrar
                        </v-btn>

                        <!-- API URL Change -->
                        <div class="mt-4">
                          <ApiUrlChange />
                        </div>
                      </v-form>

                      <!-- Formulário de Recuperação de Senha (fluxo de código) -->
                      <v-form v-else @submit.prevent="onRecoverSubmit">
                        <!-- Etapa 1: Identificador -->
                        <template v-if="forgotStep === 1">
                          <v-text-field
                            v-model="recoverUser"
                            label="Matrícula, CPF ou Email"
                            outlined
                            dense
                            required
                            autofocus
                            autocomplete="username email"
                            class="mb-4"
                            :error-messages="recoverError ? ' ' : ''"
                          ></v-text-field>
                        </template>

                        <!-- Etapa 2: Código + nova senha -->
                        <template v-else>
                          <p class="recover-hint mb-4">
                            Enviamos um código de 6 caracteres para o email
                            vinculado a <strong>{{ recoverUser }}</strong>.
                            Informe-o abaixo e defina sua nova senha.
                          </p>

                          <v-text-field
                            v-model="recoverToken"
                            label="Código recebido por email"
                            outlined
                            dense
                            required
                            autofocus
                            maxlength="6"
                            class="mb-4 recover-token-field"
                            :error-messages="recoverError ? ' ' : ''"
                            @input="onTokenInput"
                          ></v-text-field>

                          <v-text-field
                            v-model="newPassword"
                            label="Nova senha"
                            outlined
                            dense
                            required
                            autocomplete="new-password"
                            class="mb-1"
                            hint="Mínimo de 6 caracteres"
                            persistent-hint
                            :type="showNewPassword ? 'text' : 'password'"
                          >
                            <template v-slot:append>
                              <v-icon
                                small
                                @click="showNewPassword = !showNewPassword"
                                style="cursor: pointer"
                              >
                                <fa-icon
                                  :icon="showNewPassword ? 'eye-slash' : 'eye'"
                                />
                              </v-icon>
                            </template>
                          </v-text-field>

                          <v-text-field
                            v-model="confirmPassword"
                            label="Confirmar nova senha"
                            outlined
                            dense
                            required
                            autocomplete="new-password"
                            class="mb-1 mt-4"
                            :type="showNewPassword ? 'text' : 'password'"
                            :error-messages="passwordMismatch ? 'As senhas devem ser iguais.' : ''"
                          ></v-text-field>

                          <!-- Reenviar código -->
                          <div class="text-right mb-2">
                            <a
                              href="#"
                              class="forgot-password-link"
                              @click.prevent="onResendCode"
                            >
                              Reenviar código
                            </a>
                          </div>
                        </template>

                        <!-- Mensagem de Sucesso -->
                        <v-fade-transition>
                          <v-alert
                            v-if="recoverSuccess"
                            type="success"
                            dense
                            text
                            class="mb-4"
                          >
                            {{ recoverSuccess }}
                          </v-alert>
                        </v-fade-transition>

                        <!-- Mensagem de Erro -->
                        <v-fade-transition>
                          <v-alert
                            v-if="recoverError"
                            type="error"
                            dense
                            text
                            class="mb-4"
                          >
                            {{ recoverError }}
                          </v-alert>
                        </v-fade-transition>

                        <!-- Botão principal -->
                        <v-btn
                          v-if="!recoverSuccess"
                          type="submit"
                          color="primary"
                          x-large
                          block
                          elevation="4"
                          class="login-button mb-4"
                          :loading="recoverLoading"
                          :disabled="!canSubmitRecover"
                        >
                          <fa-icon icon="key" class="mr-2" />
                          {{
                            forgotStep === 1
                              ? "Enviar código de recuperação"
                              : "Redefinir senha"
                          }}
                        </v-btn>

                        <!-- Voltar -->
                        <div class="text-center">
                          <a
                            href="#"
                            class="forgot-password-link"
                            @click.prevent="onRecoverBack"
                          >
                            <fa-icon icon="arrow-left" class="mr-1" />
                            {{
                              forgotStep === 2 && !recoverSuccess
                                ? "Voltar"
                                : "Voltar ao login"
                            }}
                          </a>
                        </div>
                      </v-form>

                      <!-- Footer -->
                      <div class="footer-section mt-8">
                        <v-divider class="mb-4"></v-divider>
                        <p class="text-center text--secondary caption mb-0">
                          Desenvolvido por
                          <a
                            href="https://versotech.com.br"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="versotech-link"
                          >
                            Versotech®
                          </a>
                        </p>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-fade-transition>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import config from "../../config";
import ApiUrlChange from "../../components/ApiUrlChange.vue";
import {
  getToken,
  requestTokenResetPassword,
  validateResetToken,
  resetPasswordByToken,
} from "@/helpers/apiRequest";
import { loadCargas } from "../../helpers/cargas";
import promotionalBgImage from "@/assets/images/admin-bg.jpeg";

export default {
  name: "login",
  components: {
    ApiUrlChange,
  },
  data() {
    return {
      logo: config.api + "/images/logo/s/ADMIN",
      background: config.api + "/images/background/ADMIN",
      promotionalBg: promotionalBgImage,
      user: "",
      pass: "",
      loginError: false,
      loading: false,
      showPassword: false,
      mode: "login",
      forgotStep: 1,
      recoverUser: "",
      recoverToken: "",
      newPassword: "",
      confirmPassword: "",
      showNewPassword: false,
      recoverError: false,
      recoverSuccess: "",
      recoverLoading: false,
    };
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${this.background})`,
      };
    },
    promotionalBackground() {
      return {
        backgroundImage: `url(${this.promotionalBg})`,
      };
    },
    subtitle() {
      if (this.mode !== "forgot") {
        return "Faça login para continuar";
      }
      return this.forgotStep === 1
        ? "Informe seu identificador para receber um código por email"
        : "Informe o código recebido e defina sua nova senha";
    },
    passwordMismatch() {
      return (
        !!this.confirmPassword && this.newPassword !== this.confirmPassword
      );
    },
    canSubmitRecover() {
      if (this.forgotStep === 1) {
        return !!this.recoverUser;
      }
      return (
        this.recoverToken.length === 6 &&
        this.newPassword.length >= 6 &&
        this.newPassword === this.confirmPassword
      );
    },
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.loginError = false;

      getToken({ cpf: this.user, senha: this.pass })
        .then((json) => {
          localStorage.setItem("token", json.token);
          loadCargas(
            json.token,
            () => {
              this.$router.push({ name: "home" });
              this.loading = false;
            },
            (err) => {
              this.loading = false;
              this.loginError = err.message;
            }
          );
        })
        .catch((error) => {
          this.loading = false;
          this.loginError = error.message;
        });
    },
    switchMode(mode) {
      this.mode = mode;
      this.loginError = false;
      this.resetRecoverState();
    },
    resetRecoverState() {
      this.forgotStep = 1;
      this.recoverToken = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.showNewPassword = false;
      this.recoverError = false;
      this.recoverSuccess = "";
    },
    onTokenInput(value) {
      // O token gerado pelo backend é alfanumérico em maiúsculas (6 caracteres).
      this.recoverToken = (value || "").toUpperCase().slice(0, 6);
    },
    onRecoverSubmit() {
      if (this.forgotStep === 1) {
        this.requestCode();
      } else {
        this.resetPassword();
      }
    },
    requestCode() {
      if (!this.recoverUser) {
        this.recoverError = "Informe sua matrícula, CPF ou email.";
        return;
      }

      this.recoverLoading = true;
      this.recoverError = false;
      this.recoverSuccess = "";

      requestTokenResetPassword({ id: this.recoverUser })
        .then(() => {
          this.recoverLoading = false;
          this.forgotStep = 2;
        })
        .catch((error) => {
          this.recoverLoading = false;
          this.recoverError = error.message;
        });
    },
    onResendCode() {
      this.recoverLoading = true;
      this.recoverError = false;
      this.recoverSuccess = "";

      requestTokenResetPassword({ id: this.recoverUser })
        .then(() => {
          this.recoverLoading = false;
          this.recoverSuccess = "Um novo código foi enviado para o seu email.";
        })
        .catch((error) => {
          this.recoverLoading = false;
          this.recoverError = error.message;
        });
    },
    resetPassword() {
      if (this.recoverToken.length !== 6) {
        this.recoverError = "Informe o código de 6 caracteres recebido por email.";
        return;
      }
      if (this.newPassword.length < 6) {
        this.recoverError = "A nova senha deve conter no mínimo 6 caracteres.";
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.recoverError = "As senhas devem ser iguais.";
        return;
      }

      this.recoverLoading = true;
      this.recoverError = false;
      this.recoverSuccess = "";

      validateResetToken({ token: this.recoverToken })
        .then(() =>
          resetPasswordByToken({
            token: this.recoverToken,
            senha: this.newPassword,
          })
        )
        .then(() => {
          this.recoverLoading = false;
          this.recoverSuccess =
            "Senha redefinida com sucesso. Redirecionando para o login...";
          setTimeout(() => this.switchMode("login"), 2500);
        })
        .catch((error) => {
          this.recoverLoading = false;
          this.recoverError = error.message;
        });
    },
    onRecoverBack() {
      if (this.forgotStep === 2 && !this.recoverSuccess) {
        this.forgotStep = 1;
        this.recoverToken = "";
        this.newPassword = "";
        this.confirmPassword = "";
        this.recoverError = false;
        this.recoverSuccess = "";
        return;
      }
      this.switchMode("login");
    },
  },
};
</script>

<style scoped>
/* Container Principal */
.login-container {
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

/* Overlay Escuro */
.overlay-dark {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
}

.login-container .container {
  position: relative;
  z-index: 2;
}

/* Card Principal */
.login-card {
  border-radius: 24px !important;
  overflow: visible;
  background: transparent !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
}

/* Seção Promocional (Esquerda) */
.promotional-section {
  min-height: 600px;
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 48px;
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
  overflow: hidden;
}

.promotional-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.75) 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 48px;
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
}

.promotional-content {
  position: relative;
  z-index: 2;
}

.badge-novidade {
  display: inline-block;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 8px 16px;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.promotional-title {
  font-size: 2.5rem;
  font-weight: 700;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
}

.promotional-description {
  font-size: 1.125rem;
  line-height: 1.6;
  text-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
  opacity: 0.95;
}

/* Seção do Formulário (Direita) */
.form-section {
  padding: 48px 40px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px) saturate(100%);
  -webkit-backdrop-filter: blur(10px) saturate(100%);
  min-height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 24px;
}

@media (min-width: 960px) {
  .form-section {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.form-logo {
  max-width: 200px;
  height: auto;
}

.form-title {
  font-size: 2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.form-subtitle {
  color: #666;
  font-size: 0.95rem;
  margin-bottom: 0;
}

/* Botão de Login */
.login-button {
  font-size: 1rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  padding: 24px 0 !important;
  transition: all 0.3s ease !important;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(25, 118, 210, 0.4) !important;
}

/* Footer */
.footer-section {
  margin-top: auto;
}

.versotech-link {
  color: #2298a3;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.2s ease;
}

.versotech-link:hover {
  text-decoration: underline;
  color: #1a7a82;
}

/* Link Esqueci minha senha / Voltar ao login */
.forgot-password-link {
  color: #2298a3;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s ease;
}

.forgot-password-link:hover {
  text-decoration: underline;
  color: #1a7a82;
}

/* Recuperação de senha por código */
.recover-hint {
  color: #555;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 0;
}

.recover-token-field >>> input {
  letter-spacing: 0.4em;
  text-transform: uppercase;
  font-weight: 600;
}

/* Responsivo */
@media (max-width: 960px) {
  .form-section {
    padding: 32px 24px;
    min-height: auto;
  }

  .promotional-title {
    font-size: 2rem;
  }
}

@media (max-width: 600px) {
  .form-section {
    padding: 24px 16px;
  }

  .form-logo {
    max-width: 160px;
  }

  .form-title {
    font-size: 1.75rem;
  }
}
</style>
